var r=function(r){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=t.separator||"_",e=t.split||/(?=[A-Z])/;return r.split(e).join(o).toLowerCase()};export{r as decamelize};
//# sourceMappingURL=decamelize.js.map
